import Vue from 'vue';
import VueCookies from 'vue-cookies';
import Vuex from 'vuex';
import VueWait from 'vue-wait';
import VueRouter from 'vue-router';
import VTooltip from 'v-tooltip';
import BootstrapVue from 'bootstrap-vue';
import VueHead from 'vue-head';

Vue.use(VueHead);
Vue.use(VueCookies);
Vue.use(Vuex);
Vue.use(VueWait);
Vue.use(VueRouter);
Vue.use(VTooltip);
Vue.use(VueCookies);
Vue.use(BootstrapVue);

VTooltip.options.defaultDelay = { show: 400, hide: 150 };
Vue.$cookies.config('30d');
